import { ApiError } from '../lib/api';

export function errorMessage(e: unknown, fallback = 'Não foi possível completar a ação. Tente novamente.'): string {
  if (e instanceof ApiError) return e.message;
  if (e instanceof Error) return e.message || fallback;
  return fallback;
}

export function ErrorModalBody({ error, onClose, onRetry }: { error: unknown; onClose: () => void; onRetry?: () => void }) {
  return (
    <>
      <h2 style={{ color: 'var(--coral)' }}>Não foi possível continuar</h2>
      <p className="muted">{errorMessage(error)}</p>
      {onRetry && <button className="btn btn-primary btn-block" onClick={onRetry}>Tentar novamente</button>}
      <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={onClose}>Fechar</button>
    </>
  );
}
